import { Directive, ElementRef, HostListener } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the CatchLinksDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[catch-links]' // Attribute selector
})
export class CatchLinksDirective {

  constructor(private elem: ElementRef, private browser: InAppBrowser) {
    //   elem.('click', 'a', function(event) {
    //     event.preventDefault();
    //     this.trackEvent('Button Clicked', 'External URL', elem.attr('href'));
    //         this.cordovaInAppBrowser.open($(this).attr('href'), '_system');
    // // $cordovaInAppBrowser.open($(this).attr('href'), '_blank', {location: 'no', clearcache: 'yes', toolbar: 'yes'});
    //   });
  }
  
  // ngAfterContentInit() {
  //   let elements = this.elem.nativeElement.getElementsByTagName("a");

  //   // for (let i = 0; i <= elements.length; i++) {
  //   //   console.log('yes', elements[i]);
  //   //   try {
  //   //     elements[i].addEventListener("click", this.openUrl(elements[i]));
  //   //   } catch(ex) {

  //   //   }
  //   // }
  //   Array.from(this.elem.nativeElement.getElementsByTagName("a")).forEach((element) => {
  //     console.log('loop', element)
  //   })
  //   console.log('element list', this.elem.nativeElement.getElementsByTagName("a"));
  // }

  openUrl(element) {
    // console.log('open called', element);
    this.browser.create(element.getAttribute('href'), '_system');
  }

  @HostListener('click', ['$event']) onclick(event) {
    // console.log('poopy wiener', event);
    event.preventDefault();
    
    if (event.target.tagName.toUpperCase() === 'A') {
      // console.log(event)
      this.browser.create(event.target.getAttribute('href'), '_system');
    } else if (event.target.parentNode.tagName.toUpperCase()==='A') {
      this.browser.create(event.target.parentNode.getAttribute('href'), '_system');
    }
  }

  // trackEvent(category, action, label, value) {
  //   if(window.ga && $rootScope.gaEnabled){
  //       window.ga.trackEvent(category, action, label, value);
  //       // console.log(category, action, label, value);
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/directives/catch-links/catch-links.ts